import React from "react";
import PropTypes from "prop-types";
import withModal from "./withModal";
import { logOff, stayLoggedIn } from "../../actions/sessionActions";
import MaterialModal from "./MaterialModal";

const propTypes = {
    isOpen: PropTypes.bool.isRequired,
    modalProps: PropTypes.shape({
        minutes: PropTypes.number,
    }).isRequired,
};

type SessionTimeoutDialogProps = PropTypes.InferProps<typeof propTypes>;

const SessionTimeoutDialog: React.FC<SessionTimeoutDialogProps> = ({
    isOpen,
    modalProps,
}: SessionTimeoutDialogProps) => (
    <MaterialModal
        id="user-settings-modal"
        isOpen={isOpen}
        cancelButtonText="Continue Session"
        onClose={() => stayLoggedIn()}
        primaryButtonText="Logout"
        onPrimaryButtonRequest={() => logOff()}
        title="Are you still there?"
    >
        <p>You will be logged out in {modalProps.minutes || 3} minute(s) due to inactivity.</p>
        <p>Would you like to continue the session?</p>
    </MaterialModal>
);

SessionTimeoutDialog.defaultProps = {
    isOpen: false,
};

export default withModal(SessionTimeoutDialog, "TIMEOUT_SESSION_WARNING");
